const NotFound: React.FC = () => {
  return (
    <section className="mt-10">
      <p className="text-lg-regular">404 - Page Not Found</p>
    </section>
  );
};

export default NotFound;
